import { useState } from "react";
import { ProfileForm } from "../components/profile/ProfileForm";
import { SecurityForm } from "../components/profile/SecurityForm";

export default function Profile() {
  const [activeTab, setActiveTab] = useState<"profile" | "security">("profile");

  return (
    <div className="w-full max-w-[680px] mt-2 relative">
      {/* Tabs Row */}
      <div className="flex items-start w-full border-b border-gray-200 mb-5">
        <button
          type="button"
          onClick={() => setActiveTab("profile")}
          className={`px-[20px] py-[12px] font-semibold text-[14px] leading-tight tracking-[0.2px] border-b-2 -mb-[1px] transition-colors ${
            activeTab === "profile"
              ? "border-rodeo-black text-rodeo-black"
              : "border-transparent text-graphite hover:text-rodeo-black"
          }`}
        >
          Profile
        </button>
        <button
          type="button"
          onClick={() => setActiveTab("security")}
          className={`px-[20px] py-[12px] font-semibold text-[14px] leading-tight tracking-[0.2px] border-b-2 -mb-[1px] transition-colors ${
            activeTab === "security"
              ? "border-rodeo-black text-rodeo-black"
              : "border-transparent text-graphite hover:text-rodeo-black"
          }`}
        >
          Security
        </button>
      </div>

      {/* Tab Content */}
      <div className="w-full">
        {activeTab === "profile" && <ProfileForm />}
        {activeTab === "security" && <SecurityForm />}
      </div>
    </div>
  );
}
